import { render, staticRenderFns } from "./Pendencies.vue?vue&type=template&id=c1da6f56&scoped=true"
import script from "./Pendencies.vue?vue&type=script&lang=js"
export * from "./Pendencies.vue?vue&type=script&lang=js"
import style0 from "./Pendencies.vue?vue&type=style&index=0&id=c1da6f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1da6f56",
  null
  
)

export default component.exports